// Salesperson Analytics Redux Slice

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { salespersonApi } from '../../api/salespersonApi';

export const fetchSalespersonAnalytics = createAsyncThunk(
  'salespersonAnalytics/fetch',
  async ({ id, period, dailyFrom, dailyTo }, { rejectWithValue }) => {
    try {
      const extra = {};
      if (dailyFrom) extra.daily_from = dailyFrom;
      if (dailyTo) extra.daily_to = dailyTo;
      const res = await salespersonApi.getAnalytics(id, period, extra);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to load analytics');
    }
  }
);

const salespersonAnalyticsSlice = createSlice({
  name: 'salespersonAnalytics',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearAnalytics: (state) => { state.data = null; state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalespersonAnalytics.pending,   (state) => { state.loading = true;  state.error = null; })
      .addCase(fetchSalespersonAnalytics.fulfilled, (state, { payload }) => { state.loading = false; state.data = payload; })
      .addCase(fetchSalespersonAnalytics.rejected,  (state, { payload }) => { state.loading = false; state.error = payload; });
  },
});

export const { clearAnalytics } = salespersonAnalyticsSlice.actions;
export default salespersonAnalyticsSlice.reducer;
